module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"all":"All","driver":"Driver","truck":"Truck","no_warnings":"No warnings"},"de":{"all":"Alle","driver":"Fahrer","truck":"Fahrzeug","no_warnings":"Keine Warnungen"},"fr":{"all":"Tous","driver":"Conducteur","truck":"Camion","no_warnings":"Aucun avertissement"},"it":{"all":"Tutti","driver":"Autista","truck":"Camion","no_warnings":"Nessun avviso"}}')
  delete Component.options._Ctor
}
